<template>
  <v-tooltip bottom :max-width="maxWidth" open-on-click :open-on-hover="false" :open-delay="100">
    <template #activator="{ on }">
      <v-icon class="info-tooltip-icon" small v-on="on">
        {{ icon }}
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AuctionFormInfoTooltip',
  props: {
    text: { type: String, required: true },
    icon: { type: String, default: 'info_outline' },
    maxWidth: { type: [String, Number], default: 360 },
  },
};
</script>

<style scoped>
.info-tooltip-icon {
  color: #216169;
  cursor: pointer;
  margin-bottom: 8px;
}
</style>
